import resume1 from "../images/resume1.jpg"
import resume2 from "../images/resume2.jpg"
import resume3 from "../images/resume3.jpg"
const templates = [
	{
		id: 0,
		preview: resume1,
		name: "Nancia",
		recommended: true,
	},
	{
		id: 1,
		preview: resume2,
		name: "Enfold",
		recommended: true,
	},
	{
		id: 2,
		preview: resume3,
		name: "Iconic",
		recommended: true,
	},
	{
		id: 3,
		preview: resume1,
		name: "Cascade",
		recommended: false,
	},
	{
		id: 4,
		preview: resume2,
		name: "Concept",
		recommended: false,
	},
	{
		id: 5,
		preview: resume3,
		name: "crisp",
		recommended: false,
	},
	{
		id: 6,
		preview: resume2,
		name: "Nancia",
		recommended: true,
	},
	{
		id: 7,
		preview: resume3,
		name: "Nancia",
		recommended: true,
	},
]

export default templates
